var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    'font-size': _vm.size,
    'text-align': _vm.align,
    display: _vm.display,
    height: _vm.height,
    border: _vm.border,
    color: _vm.color,
    'border-radius': _vm.radius,
    'background-color': _vm.background,
  }),on:{"click":function($event){return _vm.openUpload()}}},[(_vm.file === null)?_c('div',{staticStyle:{"padding-top":"5px","cursor":"pointer"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{staticStyle:{"padding-top":"5px","cursor":"pointer"}},[(_vm.placeholder)?_c('div',{staticClass:"w-full"},[_vm._v(" "+_vm._s(_vm.placeholder.substr(0, 20))+" "),(_vm.placeholder.length > 20)?_c('span',[_vm._v("...")]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }